// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderLayout_wrapper__Lg+Mi","title":"HeaderLayout_title__A9qTl","subtitle":"HeaderLayout_subtitle__v5hoC","divider":"HeaderLayout_divider__EGhks"};